export default "__VITE_ASSET__DEt1sTCl__"